import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {ClientHeader} from "./ClientHeader";
import {ClientTabs} from "./ClientTabs";
import {ClientPortalTab} from "./ClientPortalTab";
import { withTranslation } from 'react-i18next';
import {SectionIntro} from "../elements/SectionIntro";

class ClientPortalTabContentClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
        };
    }

    componentDidMount() {
        this.getClientData();
    }

    getClientData() {
        new APIClient(API_URL + 'client/' + this.props.clientId).call('GET').then((data) => {
            if (data.status === 'OK') {
                this.setState({name: data.data['name']});
            }
        });
    }

    render() {
        const {t} = this.props;
        return (
            <section className="section-content client-workspace-page client-portal-page">
                <ClientHeader name={this.state.name}/>
                <ClientTabs clientId={this.props.clientId}/>
                <div className="section-body client-workspace-body">
                    <SectionIntro
                        kicker={t('client_sections.portal.kicker')}
                        title={t('client_sections.portal.title')}
                        description={t('client_sections.portal.description')}
                    />
                </div>
                <ClientPortalTab clientId={this.props.clientId}/>
            </section>
        );
    }
}

export const ClientPortalTabContent = withTranslation()(ClientPortalTabContentClass);
